import React, {useState} from 'react'
import Select from 'react-select'
import AsyncSelect from 'react-select/async'
import DatePicker from 'react-datepicker'
import {withTranslation} from 'react-i18next'
import lowerCase from 'lodash/lowerCase'
import {GroupDetailsContext} from '../../../../context/Modal/GroupDetails'
import {getSearchUsers as getSearchUsersAPI} from '../../../../services/entities'
import {AuditModalApiContext} from '../../../../context/AuditModalApi'

function AutoUpdateInputFields(props) {
  const {audit_entities_attributes, setUserField} = React.useContext(GroupDetailsContext)

  const [inputValue, setValue] = useState('')

  // handle input change event
  const handleInputChange = value => {
    setValue(value)
  }

  const handleChange = (Input, event) => {
    let field = Input
    let multiSelect_check = false
    if (!!event && !!event.target) {
      field.value_name = event.target.value
    } else if (
      Input.field_type === 'DateField' ||
      Input.field_type === 'DateTimeField' ||
      Input.field_type === 'TimeField'
    ) {
      field.value_name = event
    } else if (
      Input.field_type === 'MultipleListField' ||
      Input.field_type === 'MultipleEntityListField'
    ) {
      multiSelect_check = true
      if (event !== null && event.length > 0) {
        let uniqueMultilistArary = []
        event.map(multi_option => {
          if (uniqueMultilistArary.indexOf(multi_option.value) === -1) {
            uniqueMultilistArary.push(multi_option)
          }
          return true
        })
        field.value_name = ''
        field.value_id = ''
        field.selectedOptions = uniqueMultilistArary
      } else {
        field.selectedOptions = []
      }
    } else {
      if (Input.field_type === 'ApUserField') {
        setUserField(event)
      }
      field.value_name = event.label
      field.value_id = event.value
    }
    if (multiSelect_check) {
      multiSelect_check = false
      props.handleMultipleFieldChange(field)
    } else {
      props.handleFieldChange(field)
    }
    if (Input.is_parent) {
      //props.handleGetChildData(field)
    }
  }

  const getFieldError = id => {
    let err = false
    props.errors.map(error => {
      if (error.error_field === id) {
        err = error
      }
      return true
    })
    return err
  }
  const {t, disabled} = props
  if (props.field_data.field_type === 'TextField') {
    return (
      <div>
        <input
          className="form-control"
          type="text"
          placeholder=""
          value={props.field_data.value_name}
          defaultValue=""
          disabled={disabled}
          onChange={event => handleChange(props.field_data, event)}
        />
        {getFieldError(props.field_data.field_id) && (
          <div className="auto-text-danger">
            {getFieldError(props.field_data.field_id).error_message}
          </div>
        )}
      </div>
    )
  }
  if (props.field_data.field_type === 'ListField') {
    let listOptions = props.field_data.values.map(value => {
      return {
        label: value,
        value: value,
      }
    })
    return (
      <div>
        <Select
          className="basic-single mb-10"
          classNamePrefix="select"
          isSearchable={true}
          isDisabled={disabled}
          name="color"
          options={listOptions}
          onChange={event => handleChange(props.field_data, event)}
          value={
            props.field_data.value_name !== ''
              ? listOptions.filter(({value}) => value === props.field_data.value_name)
              : ''
          }
        />
        {getFieldError(props.field_data.field_id) && (
          <div className="auto-text-danger">
            {getFieldError(props.field_data.field_id).error_message}
          </div>
        )}
      </div>
    )
  }
  if (props.field_data.field_type === 'MultipleListField') {
    let listOptions = props.field_data.values.map(value => {
      return {
        label: value,
        value: value,
      }
    })
    return (
      <div>
        <Select
          className="basic-single mb-10"
          classNamePrefix="select"
          isSearchable={true}
          isMulti={true}
          name="color"
          isDisabled={disabled}
          options={listOptions}
          onChange={event => handleChange(props.field_data, event)}
          value={props.field_data.selectedValues}
        />
        {getFieldError(props.field_data.field_id) && (
          <div className="auto-text-danger">
            {getFieldError(props.field_data.field_id).error_message}
          </div>
        )}
      </div>
    )
  }
  if (props.field_data.field_type === 'MultipleEntityListField') {
    let parent_field_data,
      listOptions = []
    if (props.field_data.parent_id) {
      props.field_data.values.map(value => {
        if (value[3].parent_id === props.parentValue) {
          listOptions.push({
            label: value[0],
            value: value[1].$oid.toString(),
          })
        }
        return true
      })

      let index = props.all_field_data
        .map(function(e) {
          return e.field_id.toString()
        })
        .indexOf(props.field_data.parent_id + '')
      parent_field_data = props.all_field_data[index]
    } else {
      listOptions = props.field_data.values.map(value => {
        return {
          label: value[0],
          value: value[1].$oid.toString(),
        }
      })
    }
    return (
      <div>
        <Select
          className="basic-single mb-10"
          classNamePrefix="select"
          placeholder={
            props.field_data.parent_id !== ''
              ? `Select parent (${lowerCase(parent_field_data.field_name)}) value first`
              : 'Select...'
          }
          isSearchable={true}
          isMulti={true}
          isDisabled={disabled}
          name="color"
          options={listOptions}
          onChange={event => handleChange(props.field_data, event)}
          value={props.field_data.selectedValues}
        />
        {getFieldError(props.field_data.field_id) && (
          <div className="auto-text-danger">
            {getFieldError(props.field_data.field_id).error_message}
          </div>
        )}
      </div>
    )
  }
  if (props.field_data.field_type === 'CurrencyField') {
    return (
      <div>
        <input
          className="form-control"
          type="text"
          placeholder=""
          value={props.field_data.value_name}
          defaultValue=""
          disabled={disabled}
          onChange={event => handleChange(props.field_data, event)}
        />
        {getFieldError(props.field_data.field_id) && (
          <div className="auto-text-danger">
            {getFieldError(props.field_data.field_id).error_message}
          </div>
        )}
      </div>
    )
  }
  if (props.field_data.field_type === 'StatusField') {
    let listOptions = props.field_data.values.map(value => {
      return {
        label: value[0],
        value: value[1],
      }
    })
    return (
      <div>
        <Select
          className="basic-single mb-10"
          classNamePrefix="select"
          isSearchable={true}
          name="color"
          isDisabled={disabled}
          options={listOptions}
          onChange={event => handleChange(props.field_data, event)}
          value={
            props.field_data.value_id !== ''
              ? listOptions.filter(({value}) => value === props.field_data.value_id)
              : ''
          }
        />
        {getFieldError(props.field_data.field_id) && (
          <div className="auto-text-danger">
            {getFieldError(props.field_data.field_id).error_message}
          </div>
        )}
      </div>
    )
  }

  if (props.field_data.field_type === 'DateField') {
    return (
      <div>
        <DatePicker
          placeholderText="mm/dd/yyyy"
          className="form-control"
          disabled={disabled}
          onChange={event => handleChange(props.field_data, event)}
          selected={props.field_data.value_name ? new Date(props.field_data.value_name) : ''}
        />
        {getFieldError(props.field_data.field_id) && (
          <div className="auto-text-danger">
            {getFieldError(props.field_data.field_id).error_message}
          </div>
        )}
      </div>
    )
  }
  if (props.field_data.field_type === 'EntityListField') {
    let listOptions = [],
      parent_field_data
    if (props.field_data.parent_id) {
      props.field_data.values.map(value => {
        if (value[3] === undefined || value[3]?.parent_id === props.parentValue) {
          listOptions.push({
            label: value[0],
            value: value[1].$oid.toString(),
          })
        }
        return true
      })
      let index = props.all_field_data
        .map(function(e) {
          return e.field_id.toString()
        })
        .indexOf(props.field_data.parent_id + '')
      parent_field_data = props.all_field_data[index]
    } else {
      listOptions = props.field_data.values.map(value => {
        return {
          label: value[0],
          value: value[1].$oid.toString(),
        }
      })
    }
    return (
      <div>
        <Select
          className="basic-single mb-10"
          classNamePrefix="select"
          placeholder={
            props.field_data.parent_id !== '' && parent_field_data
              ? `Select parent (${lowerCase(parent_field_data.field_name)}) value first`
              : 'Select...'
          }
          isSearchable={true}
          name="color"
          isDisabled={disabled}
          options={listOptions}
          onChange={event => handleChange(props.field_data, event)}
          value={
            props.field_data.value_name !== ''
              ? listOptions.filter(({value}) => value === props.field_data.value_id + '')
              : ''
          }
        />
        {getFieldError(props.field_data.field_id) && (
          <div className="auto-text-danger">
            {getFieldError(props.field_data.field_id).error_message}
          </div>
        )}
      </div>
    )
  }
  if (props.field_data.field_type === 'DateTimeField') {
    return (
      <div>
        <DatePicker
          className="form-control"
          onChange={event => handleChange(props.field_data, event)}
          selected={props.field_data.value_name ? new Date(props.field_data.value_name) : ''}
          showTimeSelect
          timeFormat="HH:mm"
          timeIntervals={15}
          timeCaption="time"
          dateFormat="MMMM d, yyyy h:mm aa"
          disabled={disabled}
        />
        {getFieldError(props.field_data.field_id) && (
          <div className="auto-text-danger">
            {getFieldError(props.field_data.field_id).error_message}
          </div>
        )}
      </div>
    )
  }
  if (props.field_data.field_type === 'EmailField') {
    return (
      <div>
        <input
          className="form-control"
          type="text"
          placeholder=""
          value={props.field_data.value_name}
          defaultValue=""
          disabled={disabled}
          onChange={event => handleChange(props.field_data, event)}
        />
        {getFieldError(props.field_data.field_id) && (
          <div className="auto-text-danger">
            {getFieldError(props.field_data.field_id).error_message}
          </div>
        )}
      </div>
    )
  }
  if (props.field_data.field_type === 'AddressField') {
    return (
      <div>
        <input
          className="form-control"
          type="text"
          placeholder=""
          value={props.field_data.value_name}
          defaultValue=""
          disabled={disabled}
          onChange={event => handleChange(props.field_data, event)}
        />
        {getFieldError(props.field_data.field_id) && (
          <div className="auto-text-danger">
            {getFieldError(props.field_data.field_id).error_message}
          </div>
        )}
      </div>
    )
  }
  if (props.field_data.field_type === 'MemoField') {
    return (
      <div>
        <input
          className="form-control"
          type="text"
          placeholder=""
          value={props.field_data.value_name}
          defaultValue=""
          disabled={disabled}
          onChange={event => handleChange(props.field_data, event)}
        />
        {getFieldError(props.field_data.field_id) && (
          <div className="auto-text-danger">
            {getFieldError(props.field_data.field_id).error_message}
          </div>
        )}
      </div>
    )
  }
  if (props.field_data.field_type === 'NumericField') {
    return (
      <div>
        <input
          className="form-control"
          type="text"
          placeholder=""
          value={props.field_data.value_name}
          defaultValue=""
          disabled={disabled}
          onChange={event => handleChange(props.field_data, event)}
        />
        {getFieldError(props.field_data.field_id) && (
          <div className="auto-text-danger">
            {getFieldError(props.field_data.field_id).error_message}
          </div>
        )}
      </div>
    )
  }
  if (props.field_data.field_type === 'PhoneField') {
    return (
      <div>
        <input
          className="form-control"
          type="text"
          placeholder=""
          value={props.field_data.value_name}
          defaultValue=""
          disabled={disabled}
          onChange={event => handleChange(props.field_data, event)}
        />
        {getFieldError(props.field_data.field_id) && (
          <div className="auto-text-danger">
            {getFieldError(props.field_data.field_id).error_message}
          </div>
        )}
      </div>
    )
  }
  if (props.field_data.field_type === 'TimeField') {
    return (
      <div className="TimeField_only">
        <DatePicker
          className="form-control"
          onChange={event => handleChange(props.field_data, event)}
          selected={props.field_data.value_name ? new Date(props.field_data.value_name) : ''}
          showTimeSelect
          showTimeSelectOnly
          timeIntervals={15}
          disabled={disabled}
          timeCaption="Time"
          dateFormat="h:mm aa"
        />
        {getFieldError(props.field_data.field_id) && (
          <div className="auto-text-danger">
            {getFieldError(props.field_data.field_id).error_message}
          </div>
        )}
      </div>
    )
  }

  if (props.field_data.field_type === 'UrlField') {
    return (
      <div>
        <input
          className="form-control"
          type="text"
          placeholder=""
          value={props.field_data.value_name}
          disabled={disabled}
          defaultValue=""
          onChange={event => handleChange(props.field_data, event)}
        />
        {getFieldError(props.field_data.field_id) && (
          <div className="auto-text-danger">
            {getFieldError(props.field_data.field_id).error_message}
          </div>
        )}
      </div>
    )
  }
  if (props.field_data.field_type === 'ApUserField') {
    let listOptions = [],
      newOptions = []

    listOptions = props.field_data.values.map(value => {
      return {
        label: value.first_name + ' ' + value.last_name,
        value: value.id,
      }
    })

    const loadOptions = async () => {
      const response = await getSearchUsersAPI(audit_entities_attributes[0].entity_id, inputValue)
      await response.data.forEach(function(data) {
        newOptions.push({
          label: data.data.full_name.data,
          value: data.id,
        })
      })
      return newOptions
    }

    return (
      <div>
        <AsyncSelect
          cacheOptions
          className="basic-single mb-10"
          classNamePrefix="select"
          isDisabled={disabled}
          loadOptions={loadOptions}
          defaultOptions={listOptions}
          onChange={event => handleChange(props.field_data, event)}
          onInputChange={handleInputChange}
          value={
            props.field_data.value_name !== ''
              ? {label: props.field_data.value_name, value: props.field_data.value_id}
              : ''
          }
        />
        {getFieldError(props.field_data.field_id) && (
          <div className="auto-text-danger">
            {getFieldError(props.field_data.field_id).error_message}
          </div>
        )}
      </div>
    )
  }
  if (props.field_data.field_type === 'YesNoField') {
    return (
      <div className="styled_radio">
        <div className="row col-12">
          <div className="col-4 padding-right-0 padding-left-0">
            <input
              className={
                props.field_data.value_name === 'Yes'
                  ? 'form-control height-17 input-padding-9 mt-6 rediobox_style checked'
                  : 'form-control height-17 input-padding-9 mt-6 rediobox_style'
              }
              value="Yes"
              type="radio"
              id={props.field_data.field_id}
              disabled={disabled}
              onChange={event => handleChange(props.field_data, event)}
              checked={props.field_data.value_name === 'Yes'}
            />
            <label htmlFor={props.field_data.field_id} className="line_height_29 cursor-pointer">
              {t('audit.form-auto-update-input-fields.yes')}
            </label>
          </div>
          <div className="col-4 padding-right-0 padding-left-0">
            <input
              className={
                props.field_data.value_name === 'No'
                  ? 'form-control height-17 input-padding-9 mt-6 rediobox_style checked'
                  : 'form-control height-17 input-padding-9 mt-6 rediobox_style'
              }
              value="No"
              type="radio"
              id={props.field_data.field_id + '_2'}
              disabled={disabled}
              onChange={event => handleChange(props.field_data, event)}
              checked={props.field_data.value_name === 'No'}
            />
            <label
              htmlFor={props.field_data.field_id + '_2'}
              className="line_height_29 cursor-pointer"
            >
              No
            </label>
          </div>
        </div>
        {getFieldError(props.field_data.field_id) && (
          <div className="auto-text-danger">
            {getFieldError(props.field_data.field_id).error_message}
          </div>
        )}
      </div>
    )
  }
}

export default withTranslation()(AutoUpdateInputFields)
